import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
} from '@mui/material';
import '../../styles/signUpDialog.css'
import InputStyle from '../../assets/InputStyle';
import { useState } from 'react';
import ForgetPasswordOtpModal from './ForgetPasswordOtpModal';
import { useDispatch } from 'react-redux';
import { emailOTPToForgotPassword, phoneOTPToForgotPassword } from '../../actions/userAuth';
import { isValidPhoneNumber, isValidateEmail, validateEmail } from '../../utils/common';
import { closeSnackbar, enqueueSnackbar } from 'notistack';
import CloseIcon from '@mui/icons-material/Close';

export default function ForgetPasswordModal({ forgetPasswordAction, setForgetPasswordAction }) {
  const [forgetPasswordOtpAction, setForgetPasswordOtpAction] = useState(false);
  const [emailOrPhone, setEmailOrPhone] = useState("");
  const [otpToken, setOtpToken] = useState("");
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  const closeHandler = (event, reason) => {
    if (reason && reason == "backdropClick")
      return;
    setForgetPasswordAction(false);
  }

  const handleSubmit = (event) => {
    setLoading(true);
    if (isValidateEmail(emailOrPhone)) {
      dispatch(emailOTPToForgotPassword({ email: emailOrPhone }, (data) => {
        enqueueSnackbar("Otp sent successfully", {variant: 'success'});
        setOtpToken(data.data.otpToken);
        setLoading(false);
        setForgetPasswordOtpAction(true);
        setForgetPasswordAction(false);
      }, (err) => {
        enqueueSnackbar(err.response.data.msg, { variant: 'error' });
        setLoading(false);
      }))
    } else if (isValidPhoneNumber(emailOrPhone)) {
      dispatch(phoneOTPToForgotPassword({ phone: emailOrPhone.includes('+') ? emailOrPhone : `+91${emailOrPhone}` }, (data) => {
        enqueueSnackbar("Otp sent successfully", {variant: 'success'});
        setOtpToken(data.data.otpToken);
        setLoading(false);
        setForgetPasswordOtpAction(true);
        setForgetPasswordAction(false);
      }, (err) => {
        enqueueSnackbar(err.response.data.msg, { variant: 'error' });
        setLoading(false);
      }))
    } else {
      enqueueSnackbar("please enter a valid email or phone", { variant: 'error' });
      setLoading(false);
    }
    event.preventDefault();
  }

  return (
    <>
      <Dialog
        open={forgetPasswordAction}
        onClose={closeHandler}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle>
          <CloseIcon sx={{float:'right', cursor:'pointer'}} onClick={closeHandler}/>
        </DialogTitle>
        <DialogContent >
          <Box px={6} py={3}>
            <Typography

              sx={{ fontWeight: 700, mb: 4, textAlign: 'center', color: '#2544EE', fontSize: 22, fontFamily: 'Inter', }}
              component={'h3'}
            >
              Forget Password
            </Typography>

            <Stack spacing={3} pt={1} >

              <InputStyle name="Email/Phone Number" topSpace={true}>
                <input type="text" placeholder="Enter your email/Phone Number" value={emailOrPhone} onChange={(e) => setEmailOrPhone(e.target.value)} />
              </InputStyle>

              <Button disabled={loading} onClick={handleSubmit} variant="contained" fullWidth sx={{ bgcolor: '#2544EE', width: '92%' }}>
                {
                  loading
                    ?
                    <CircularProgress size={24} />
                    :
                    "Submit"
                }
              </Button>

            </Stack>

          </Box>
        </DialogContent>
      </Dialog>
      <ForgetPasswordOtpModal
        emailOrPhone={emailOrPhone}
        forgetPasswordOtpAction={forgetPasswordOtpAction}
        otpToken={otpToken}
        setForgetPasswordOtpAction={setForgetPasswordOtpAction}
      />
    </>
  );
}
